export enum EditionEnum {
  Standard = 'Standard',
  Professional = 'Professional',
  Enterprise = 'Enterprise',
}
